import axios from 'axios';
import lib from '@/lib';

export default class AuthModel
{
	/**
	 * Конструктор
	 */
	constructor()
	{
		// Инициализация
		this.authChecked = false;
		this.token = localStorage.getItem('token')||'';
		
		this.userProfile = null;
		
		if (this.token) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
		}
		axios.defaults.headers.common['Content-Type'] = 'application/json';
	}
	
	/**
	 * Инициализация данных пользователя
	 */
	async doInitData()
	{
		if (!this.authChecked && this.token) {
			try {
				const response = await axios.get('/api/user/get-init-data', {
					withCredentials: true,
				});
				this.setUserProfile(response.data.user_data);
				this.authChecked = true;
			} catch (error) {
				console.error(error);
				if (error.response) {
					return {
						success: false,
						...error.response.data,
					};
				} else {
					return {
						success: false,
						error: error.message,
					};
				}
			}
		}
		return {
			success: true,
		};
	}
	
	/**
	 * Авторизация администратора
	 */
	async doLogin(email, password)
	{
		try {
			const response = await axios.post('/api/auth/login', {
				email,
				password,
			}, {
				withCredentials: true,
			});
			const data = response.data;
			if (data.error && data.error !== '') {
				console.error(data.error || '');
				this.userProfile = null;
				localStorage.removeItem('token');
				this.token = '';
				delete axios.defaults.headers.common['Authorization'];
				this.authChecked = false;
				return {
					success: false,
					code: data.code,
					error: data.error,
				};
			}
			const token = data.token;
			localStorage.setItem('token', token);
			this.token = token;
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			this.setUserProfile(data.user_data);
			this.authChecked = true;
			return {
				success: true,
			};
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			localStorage.removeItem('token');
			this.token = '';
			delete axios.defaults.headers.common['Authorization'];
			this.authChecked = false;
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Регистрация пользователя
	 */
	async doRegister(params = {})
	{
		try {
			const response = await axios.post('/api/auth/register', params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Деавторизация
	 */
	async doLogout()
	{
		this.userProfile = null;
		localStorage.removeItem('token');
		this.token = '';
		delete axios.defaults.headers.common['Authorization'];
		this.authChecked = false;
		
		return true;
	}
	
	isAuth()
	{
		return this.token != '' && this.userProfile != null;
	}
	
	isAdmin()
	{
		return this.userProfile?.isAdmin||false;
	}
	
	getUserId()
	{
		return this.userProfile?.user_id||'';
	}
	
	/**
	 * Устанавливает user profile
	 */
	setUserProfile(res)
	{
		if(res == null){
			this.userProfile = null;
		} else {
			this.userProfile = {
				user_id: res.id,
				firstname: res.firstname,
				lastname: res.lastname,
				email: res.email,
				phone: res.phone,
				country: res.country,
				city: res.city,
				postalCode: res.postalCode,
				address: res.address,
				isAdmin: res.isAdmin,
			};
		}
	}
}
